import React from "react";
import { Helmet } from 'react-helmet-async';
import "../../../assets/styles/Ecommerce.css";
import ecommerceHero from "../../../assets/images/ecommercedevelopment.jpg";
import ecommerceShop from "../../../assets/images/ecommercedevelopment.jpg";

const EcommerceDevelopment = () => {
  return (
    <>
    <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Ecommerce Development – BuddyTech Solutions </title>
        <meta name="description" content="Scalable e‑commerce platforms with secure payments and optimized user conversion." />
        <meta name="keywords" content="ecommerce development, online store" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Ecommerce Development – BuddyTech Solutions" />
        <meta property="og:description" content="Scalable e‑commerce platforms with secure payments and optimized user conversion." />
        <meta property="og:keywords" content="ecommerce development, online store" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/development/ecommerce" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Ecommerce Development – BuddyTech Solutions" />
        <meta name="twitter:description" content="Scalable e‑commerce platforms with secure payments and optimized user conversion." />
        <meta name="twitter:keywords" content="ecommerce development, online store" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
 </Helmet>
    <div className="ecommerce-container">
      <header className="ecommerce-hero">
        <div className="ecommerce-hero-content">
          <h1>E-commerce Development</h1>
          <p>
            We build scalable and conversion-driven e-commerce platforms that help you sell more and grow faster.
          </p>
        </div>
        <img src={ecommerceHero} alt="Ecommerce Development" className="ecommerce-hero-img" />
      </header>

      <section className="ecommerce-section">
        <div className="ecommerce-text">
          <h2>What We Offer</h2>
          <p>
            From storefront design to payment integrations and order management, we deliver end-to-end e-commerce solutions tailored to your brand and audience.
          </p>
          <ul>
            <li>Custom Online Store Development</li>
            <li>Shopping Cart & Checkout Integration</li>
            <li>Secure Payment Gateways</li>
            <li>Inventory & Order Management</li>
            <li>Marketing & SEO Features</li>
          </ul>
        </div>
        <img src={ecommerceShop} alt="Online Shop UI" className="ecommerce-img" />
      </section>

      <section className="ecommerce-platforms">
        <h2>Platforms & Tools</h2>
        <div className="platforms-grid">
          <span>Shopify</span>
          <span>WooCommerce</span>
          <span>Magento</span>
          <span>BigCommerce</span>
          <span>React</span>
          <span>Next.js</span>
          <span>Stripe</span>
          <span>PayPal</span>
          <span>Firebase</span>
          <span>MySQL / MongoDB</span>
        </div>
      </section>

      <section className="contact-options">
        <div className="contact-card email">
          <h2>📧 Email</h2>
          <p>Send us an email for inquiries, support or collaboration opportunities.</p>
          <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
            Send Email 
          </a>
        </div>

        <div className="contact-card whatsapp">
          <h2>💬 WhatsApp</h2>
          <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
          <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
            Chat on WhatsApp
          </a>
        </div>

        <div className="contact-card phone">
          <h2>📞 Call Us</h2>
          <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
          <a href="tel:+919842084312">Call Us</a>
        </div>
      </section>
    </div>
    </>
  );
};

export default EcommerceDevelopment;
